import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import {IShipmentCountByDestinationRegion} from "./ShipmentCountByDestinationRegion.types";

export default class ShipmentCountByDestinationRegionApi {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/ShipmentCountByDestinationRegion`, {params: rawQuery});
            return res.data as IWidgetResponse<IShipmentCountByDestinationRegion>;
        } catch (e: any) {
            console.error('Could not get ShipmentCountByDestinationRegion data: ', e.message);
            return undefined;
        }
    }
}